'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var data = _ref.data,
        _ref$inputFormat = _ref.inputFormat,
        inputFormat = _ref$inputFormat === undefined ? 'dhis' : _ref$inputFormat,
        _ref$outputFormat = _ref.outputFormat,
        outputFormat = _ref$outputFormat === undefined ? 'highcharts' : _ref$outputFormat,
        seriesId = _ref.seriesId,
        categoryId = _ref.categoryId,
        error = _ref.error,
        warning = _ref.warning;

    var _validator = _validators2.default[inputFormat] || _validators2.default.noValidation;
    var _adapter = _adapters2.default[inputFormat + '_' + outputFormat];

    if (_validator === _validators2.default.noValidation) {
        warning('Validation not supported for data input format "' + inputFormat + '"');
    }

    if (!_adapter) {
        error('Data tranformation from "' + inputFormat + '" to "' + outputFormat + '" is not supported');
    }

    this.data = data;

    this.generateData = function (_ref2) {
        var _ref2$seriesId = _ref2.seriesId,
            seriesId = _ref2$seriesId === undefined ? seriesId : _ref2$seriesId,
            _ref2$categoryId = _ref2.categoryId,
            categoryId = _ref2$categoryId === undefined ? categoryId : _ref2$categoryId;

        return _adapter({
            data: _validator({ data: data, error: error, warning: warning }),
            seriesId: seriesId,
            categoryId: categoryId
        });
    };
};

var _validators = require('./validators');

var _validators2 = _interopRequireDefault(_validators);

var _adapters = require('./adapters');

var _adapters2 = _interopRequireDefault(_adapters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/store/index.js
 ** module id = 224
 ** module chunks = 0 1
 **/